import { render, staticRenderFns } from "./template.html?vue&type=template&id=146897f5&scoped=true&"
import script from "./VideoWithButton.vue?vue&type=script&lang=js&"
export * from "./VideoWithButton.vue?vue&type=script&lang=js&"
import style0 from "./VideoWithButton.vue?vue&type=style&index=0&id=146897f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146897f5",
  null
  
)

export default component.exports